import { GetStorageComponent, getUserStorageComponent } from '../../utils/storage';
import axios from '../../utils/axios';
import { ThunkAction } from 'redux-thunk';
import { showError } from '../../utils/alertNotification';
import { UserProgressActionTypes } from '../courseProgressTrack/types';
export enum ActionTypes {
  QUIZ_FETCH = 'QUIZ_FETCH',
  QUIZ_SAVE = 'QUIZ_SAVE',
  QUIZ_ERROR = 'QUIZ_ERROR',
  DEFAULT = 'DEFAULT',
}

export interface QuizAction {
  type: ActionTypes;
  payload: {};
}

export function fetchQuiz(
  courseId: string,
  onSuccess: () => void,
  onError: () => void,
): ThunkAction<void, void, void, any> {
  const accessToken = GetStorageComponent('access_token');
  return dispatch => {
    return axios
      .request({
        method: 'GET',
        url: `/quizzes/${courseId}`,
        headers: {
          Authorization: 'bearer ' + accessToken,
        },
      })
      .then(response => {
        if (response.data) {
          dispatch({
            type: ActionTypes.QUIZ_FETCH,
            payload: response.data,
          });
          onSuccess();
        }
      })
      .catch(error => {
        onError();
      });
  };
}

export const submitResult = (
  quizId: string,
  values: any,
  programId: string,
  batchId: string,
  updateStatus: (value: any) => void,
  showerror: boolean,
) => (dispatch: any): Promise<any> => {
  const accessToken = GetStorageComponent('access_token');
  const userInfo = getUserStorageComponent('userinfo');
  return new Promise((resolve, reject) => {
    axios
      .request({
        method: 'POST',
        url: `/v2/track`,
        headers: {
          Authorization: 'bearer ' + accessToken,
        },
        data: {
          videoId: values.videoId || null,
          ...values.tracker,
          quizAnswerSubmissionDto: {
            quizId,
            userId: userInfo.id,
            questionAnswers: values.questionAnswers,
          },
          programId,
          batchId,
        },
      })
      .then(response => {
        dispatch({
          type: UserProgressActionTypes.USER_PROGRESS_TRACK,
          payload: response.data.userProgressTrackerDto,
        });
        resolve(response.data);
      })
      .catch(error => {
        if (error.data) {
          showError(error.data.message);
        }
        reject();
      });
  });
};
